import { KybDocument, KybDocumentStatus } from '__generated__/GQL';
import assertNever from 'common/bento/lib/assertNever';

import { VerificationStatus } from '../../Verification/lib/steps/types';
import getMandateDocument from './getMandateDocument';

type GetMandateModuleStatusProps = {
  kybDocuments: Pick<KybDocument, 'type' | 'status'>[];
  isMandatee: boolean;
};

const getMandateStatus = ({
  isMandatee,
  kybDocuments,
}: GetMandateModuleStatusProps) => {
  if (!isMandatee) {
    return VerificationStatus.Irrelevant;
  }

  const mandateDocument = getMandateDocument({ kybDocuments });

  if (mandateDocument === undefined) {
    return VerificationStatus.ToDo;
  }

  switch (mandateDocument.status) {
    case KybDocumentStatus.Pending:
    case KybDocumentStatus.Validated:
      return VerificationStatus.Completed;

    case KybDocumentStatus.Refused:
      return VerificationStatus.Invalid;

    case KybDocumentStatus.Missing:
      return VerificationStatus.ToDo;

    default:
      return assertNever(mandateDocument.status);
  }
};

export default getMandateStatus;
